/* eslint-disable no-useless-catch */
// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../../../sharedmodules/services/fetch';
import { buildSearchParams } from '../../dealer-search/service/search-params';

const basePath = '/api';

const headerOptions = (accessToken) => ({
    Authorization: accessToken ? `Bearer ${accessToken}` : '',
});

export async function getDetails(getAccessToken, pin) {

    const endPoint = `${basePath}/products/${pin}`;
    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
            'content-type': 'application/json',
        },
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        throw response;

    }

}

export async function getDealer(getAccessToken, account) {

    const endPoint = `${basePath}/dealers/${account}`;

    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
            'content-type': 'application/json',
        },
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        throw response;

    }

}

export async function getDivision(getAccessToken) {

    const endPoint = `${basePath}/dealers/constants?id=DIVISION`;

    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
            'content-type': 'application/json',
        },
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        throw response;

    }

}

export async function getDealerResults(getAccessToken, params) {

    const searchParams = buildSearchParams(params).join('&');

    const endPoint = `${basePath}/dealers?${searchParams}`;
    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
            'content-type': 'application/json',
        },
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (response) {

        throw response;

    }

}

export async function createNewTransfer(getAccessToken, newTransfer) {

    const endPoint = `${basePath}/admin/transfers`;
    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
        },
        body: JSON.stringify(newTransfer),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (error) {

        throw error;

    }

}

export async function getLatestPerUnitMeasurements(getAccessToken, data) {

    const endPoint = `${basePath}/products/${data.pin}/measurement-readings?latestPerUnit=true`;

    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
            'content-type': 'application/json',
        },
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (error) {

        throw error;

    }

}
